module.exports = __webpack_public_path__ + "static/icons/icon-map--turkey-8dea1954bb51350e1a0a992c1a416d29.svg";